import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
  selector: 'cv-pick-game-type',
  templateUrl: './pick-game-type.component.html',
  styleUrls: ['./pick-game-type.component.scss']
})
export class PickGameTypeComponent implements OnInit {
  @Output() onGametypeSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() previousView: EventEmitter<any> = new EventEmitter<any>();

  @Input() isCxone: boolean;

  games: any;
  gs: any = null;
  allActiveGames: any;
  showingDetails: boolean = false;

  constructor(
    private gamesService: GamesService,
    private cvLocalization: CVLocalizationService,
  ) { }

  async ngOnInit(): Promise<void> {
    if (this.isCxone) {
      await this.cvLocalization.GetSection('Games');
    }
    this.games = await this.gamesService.getGameDefinitions();
    
    if (!this.isCxone) {
      this.allActiveGames = this.games.filter((def: any) => { return def.Active; }).sort((a: any, b: any) => { return b.GameType - a.GameType });
    } else {
      this.allActiveGames = this.games.filter((e: any) => e.GameType < 9).filter((def: any) => { return def.Active; }).sort((a: any, b: any) => { return b.GameType - a.GameType });
    }
    this.gs = this.gamesService.data;
  }

  selectGametype(def: any): void {
    this.onGametypeSelected.emit(def);
  };

  clickPreviousView(): void {
    this.previousView.emit();
  };

  showDetails(): void {
    this.showingDetails = true;
  }

  hideDetails(): void {
    this.showingDetails = false;
  };

  getLocalizedMessage(key: string, value: string): string {
    return this.gamesService.getLocalizedMessage(key, value);
  }

  getLocalizationString(key: string, defaultValue: string) {
    return this.cvLocalization.getCachedText("Admin", key, defaultValue);
  }
}